import Markdoc from '@markdoc/markdoc';
import classNames from 'classnames';
import React from 'react';
import {
  markdocComponentsConfig,
  markdocTagConfig,
} from '../../helpContext/help.config';

export interface MarkdownContentProps {
  children?: React.ReactNode;
  content: string;
  className?: string;
}

const MarkdownContent: React.FC<MarkdownContentProps> = ({
  content,
  children,
  className,
}) => {
  if (!content) return null;

  const tokenizer = new Markdoc.Tokenizer({
    allowComments: true,
  });

  const tokens = tokenizer.tokenize(content);
  const ast = Markdoc.parse(tokens);
  const transformed = Markdoc.transform(ast, markdocTagConfig);

  return (
    <div
      id="HelpContainer"
      className={classNames('markdown-content', className)}
    >
      {children}
      {Markdoc.renderers.react(transformed, React, {
        components: markdocComponentsConfig as Record<
          string,
          React.ComponentType<any>
        >,
      })}
    </div>
  );
};

export default MarkdownContent;
